import styled from '@emotion/styled';
import { Helmet } from 'react-helmet';
import { EmotionBreakpoint, useBrandDetails } from 'dw-au-react-components';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Accordion, AccordionHeader } from '../components/Accordion';
import { FaqContext } from '../context/FaqProvider';
import FaqMainLayout from '../layouts/FaqMainLayout';

const StyledAccordionLayout = styled.div`
	background: #ffffff;
	border: 1px solid #e3e3e3;
	border-radius: 4px;
	padding: 20px;
	${EmotionBreakpoint('mobile')} {
		border: none;
		padding: 0;
		background: none;
	}
`;

function Faq() {
	const brandData = useBrandDetails();
	let { section = 'wine-plans', question } = useParams();
	const { faqData, privacyAndTerms } = useContext(FaqContext);
	const [questionData, setQuestionData] = useState(null);
	const [faqTitle, setFaqTitle] = useState(null);

	useEffect(() => {
		if (section) {
			const filteredFaq = faqData.filter((data) => {
				return data.slug === section;
			});
			setQuestionData(filteredFaq[0]?.questions);
			setFaqTitle(filteredFaq[0]?.title);
		}
	}, [faqData, section]);

	return (
		<FaqMainLayout>
			<Helmet>
				<title>
					{faqTitle ? faqTitle + ' - ' : ''}FAQ - {brandData.name}
				</title>
			</Helmet>

			<StyledAccordionLayout>
				<AccordionHeader
					title={section}
					faqData={faqData}
					privacyData={privacyAndTerms}
				/>
				<Accordion questionData={questionData} question={question} />
			</StyledAccordionLayout>
		</FaqMainLayout>
	);
}

export default Faq;
